module.exports = global.ENV_CONFIGURATION;
